import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import vuetify from './plugins/vuetify';
import VueApexCharts from 'vue-apexcharts'
Vue.component('v-apexchart', VueApexCharts);

import "./style.css";


Vue.config.productionTip = false;

Vue.filter('iqd', function (value) {
  if (!value && value !== 0) return ''
  const number = parseFloat(value)
  if (isNaN(number)) return value
  return number.toLocaleString('en-IQ', { maximumFractionDigits: 0 })
})

const IRAQ_TIMEZONE = 'Asia/Baghdad'

Vue.filter('iraqDate', function (value) {
  if (!value) return ''
  const d = new Date(value)
  if (isNaN(d.getTime())) return value
  return d.toLocaleDateString('en-GB', { timeZone: IRAQ_TIMEZONE })
})

Vue.filter('iraqTime', function (value) {
  if (!value) return ''
  const d = new Date(value)
  if (isNaN(d.getTime())) return String(value)
  return d.toLocaleTimeString('en-GB', {
    timeZone: IRAQ_TIMEZONE,
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  })
})

Vue.filter('iraqDateTime', function (value) {
  if (!value) return ''
  const d = new Date(value)
  if (isNaN(d.getTime())) return String(value)
  const date = d.toLocaleDateString('en-GB', { timeZone: IRAQ_TIMEZONE })
  const time = d.toLocaleTimeString('en-GB', {
    timeZone: IRAQ_TIMEZONE,
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  })
  return `${date} ${time}`
})

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app');